import { Reducer } from 'redux';
import { ExchangeConfigActionEnum, ExchangeConfigActions, IExchangeConfigState } from '.';
import {
  IExchangeConfig
} from '../../services';

export const initialState: IExchangeConfigState = {
  loading: true,
  exchangeConfig: {} as IExchangeConfig,
  exchangeConfigs: [] as IExchangeConfig[],
  exceptionMessage: "",
  message: "",
};

export const exchangeConfigReducer: Reducer<IExchangeConfigState, ExchangeConfigActions> = (
    state = initialState,
    action: ExchangeConfigActions
) => {
    switch (action.type) {
        case ExchangeConfigActionEnum.FetchExchangeConfig:
      return {
        ...state,
        loading: true,
            };
        case ExchangeConfigActionEnum.FetchExchangeConfigSuccess:
      return {
        ...state,
          loading: false,
          exchangeConfigs: action.state?.exchangeConfigs,
            };
        case ExchangeConfigActionEnum.FetchExchangeConfigFailed:
      return {
        ...state,
        loading: false,
        exceptionMessage: action.state?.exceptionMessage,
           };
        case ExchangeConfigActionEnum.PostExchangeConfig:
        return {
          ...state,
          loading: true,
          message:"",
          isPostExchangeConfigSuccess: false
        };
        case ExchangeConfigActionEnum.PostExchangeConfigSuccess:
        return {
          ...state,
          loading: false,
          exchangeConfig: action.state?.exchangeConfig,
          message: "",
          isPostExchangeConfigSuccess: true
        };
        case ExchangeConfigActionEnum.PostExchangeConfigFailed:
        return {
          ...state,
          loading: false,
          message: action.state?.exceptionMessage,
          isPostExchangeConfigSuccess: false
        };
    default:
      return state;
  }
};
